import React from 'react';
import './CustomTabs.css';

const CustomTabs = ({ value, onChange, children, sx = {} }) => {
    return (
        <div className="custom-tabs" style={sx}>
            <div className="custom-tabs-list" role="tablist">
                {React.Children.map(children, (child, index) => {
                    if (React.isValidElement(child)) {
                        return React.cloneElement(child, {
                            index,
                            active: value === index,
                            onClick: () => onChange(null, index)
                        });
                    }
                    return child;
                })}
            </div>
            <div className="custom-tabs-indicator-container">
                <div 
                    className="custom-tabs-indicator" 
                    style={{
                        left: `${(value / React.Children.count(children)) * 100}%`,
                        width: `${100 / React.Children.count(children)}%`
                    }}
                />
            </div>
        </div>
    );
};

const CustomTab = ({ 
    label, 
    icon, 
    index, 
    active, 
    onClick, 
    disabled = false 
}) => {
    return (
        <button
            className={`custom-tab ${active ? 'custom-tab-active' : ''} ${disabled ? 'custom-tab-disabled' : ''}`}
            onClick={onClick}
            disabled={disabled}
            role="tab"
            aria-selected={active}
            tabIndex={active ? 0 : -1}
        >
            {icon && <span className="custom-tab-icon">{icon}</span>}
            <span className="custom-tab-label">{label}</span>
        </button>
    );
};

export { CustomTabs, CustomTab };